/**
 * Journal articles — soften links to retired / unavailable products in prose.
 * Product placeholders are handled server-side; this covers inline /products/ links.
 */
(function () {
  var prose = document.querySelector('.article-journal__prose');
  if (!prose) return;

  var links = prose.querySelectorAll('a[href*="/products/"]');
  if (!links.length) return;

  links.forEach(function (link) {
    var match = link.pathname.match(/\/products\/([^/]+)/);
    if (!match) return;
    var handle = match[1];

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) {
          unwrapLink(link);
          return null;
        }
        return res.json();
      })
      .then(function (product) {
        if (product && product.available === false) {
          unwrapLink(link);
        }
      })
      .catch(function () {});
  });

  function unwrapLink(link) {
    var span = document.createElement('span');
    span.innerHTML = link.innerHTML;
    link.replaceWith(span);
  }
})();
